const getEntryId = (entry) => entry?.id || entry?.wrestlerId || null;

export const getFactionStoredWrestlers = (faction) => {
  if (Array.isArray(faction?.wrestlers) && faction.wrestlers.length > 0) {
    return faction.wrestlers
      .map((entry) => {
        const id = getEntryId(entry);
        return id ? { ...entry, id, wrestlerId: id } : null;
      })
      .filter(Boolean);
  }

  const costs = Array.isArray(faction?.costs) ? faction.costs : [];
  const ids = Array.isArray(faction?.wrestlerIds) ? faction.wrestlerIds : [];
  const fallbackIds = ids.length > 0
    ? ids
    : costs.map((entry) => getEntryId(entry)).filter(Boolean);

  return fallbackIds.map((id) => {
    const costEntry = costs.find((entry) => getEntryId(entry) === id) || {};
    return {
      ...costEntry,
      id,
      wrestlerId: id,
    };
  });
};

export const getFactionWrestlerIds = (faction) =>
  getFactionStoredWrestlers(faction)
    .map((entry) => entry.id)
    .filter(Boolean);

export const buildFactionMemberFields = (wrestlers = []) => {
  const normalized = wrestlers
    .map((entry) => {
      const id = getEntryId(entry);
      if (!id) return null;

      return {
        ...entry,
        id,
        wrestlerId: id,
      };
    })
    .filter(Boolean);

  return {
    wrestlers: normalized.map((entry) => ({
      id: entry.id,
      cost: entry.cost || 0,
      startScore: entry.startScore || 0,
      accumulatedPoints: entry.accumulatedPoints || 0,
      status: entry.status || null,
    })),
    wrestlerIds: normalized.map((entry) => entry.id),
    costs: normalized.map((entry) => ({
      wrestlerId: entry.id,
      cost: entry.cost || 0,
      startScore: entry.startScore || 0,
      accumulatedPoints: entry.accumulatedPoints || 0,
      currentScore: entry.currentScore ?? entry.score ?? 0,
      status: entry.status || null,
    })),
  };
};

export const mergeFactionWrestlersWithDetails = (faction, wrestlersById = {}) =>
  getFactionStoredWrestlers(faction).map((entry) => {
    const id = entry.id;
    const wrestler = wrestlersById[id] || {};

    return {
      ...entry,
      ...wrestler,
      id,
      wrestlerId: id,
      name: wrestler.name || entry.name || `Wrestler ${id}`,
      score: wrestler.score ?? entry.score ?? 0,
      cost: entry.cost || 0,
      startScore: entry.startScore || 0,
      accumulatedPoints: entry.accumulatedPoints || 0,
      currentScore: entry.currentScore ?? wrestler.score ?? entry.score ?? 0,
      status: entry.status || null,
      brand: wrestler.brand || entry.brand || '',
      imageUrl: wrestler.imageUrl || entry.imageUrl || '/assets/default-wrestler.png',
      championImages: wrestler.championImages || entry.championImages || [],
      championTypes: wrestler.championTypes || entry.championTypes || [],
      gender: wrestler.gender || entry.gender || null,
      isInjured: wrestler.isInjured ?? entry.isInjured ?? false,
    };
  });

export const buildFactionWrestlersFromSelection = (selectedWrestlers, wrestlerScores = {}) =>
  selectedWrestlers.map((wrestler) => ({
    id: wrestler.id,
    cost: wrestler.price || 0,
    startScore: wrestlerScores[wrestler.id] || 0,
    status: wrestler.status || null,
  }));
